import type { IDiscountNavigationResult } from "./DiscountNavigation";

export function add(navigationResult: IDiscountNavigationResult): void {
    if (!window.localStorage || !navigationResult || !navigationResult.storageKey) {
        return;
    }

    if (navigationResult.append === false) {
        localStorage.setItem(
            navigationResult.storageKey,
            JSON.stringify(navigationResult.storageItem),
        );
        return;
    }

    if (navigationResult.append === true) {
        let nav = null;
        const navValue = localStorage.getItem(navigationResult.storageKey);

        if (!navValue) {
            nav = navigationResult.storageItem;
        } else {
            const storedItems = JSON.parse(navValue);

            const itemsToAdd = [];

            for (let i = 0; i < navigationResult.storageItem.items.length; i = +1) {
                let exists = false;

                for (let j = 0; j < storedItems.items.length; j += 1) {
                    if (
                        storedItems.items[j] &&
                        navigationResult.storageItem.items[i] &&
                        storedItems.items[j].id === navigationResult.storageItem.items[i].id
                    ) {
                        exists = true;
                        break;
                    }
                }

                if (exists === false) {
                    itemsToAdd.push(navigationResult.storageItem.items[i]);
                }
            }

            Array.prototype.push.apply(storedItems.items, itemsToAdd);

            nav = { ...navigationResult.storageItem, items: storedItems.items };
        }

        localStorage.setItem(navigationResult.storageKey, JSON.stringify(nav));
    }
}
